module.exports = __webpack_public_path__ + "static/media/21ECLAC26.4fad9d73.jpg";